import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import './App.scss';
import { useLocation } from './routing';
import { Link } from './routing';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import PageTransition from './components/PageTransition/PageTransition';
import HomePage from './pages/Home/HomePage';
import ServicePage from './pages/Service/ServicePage';
import ContactPage from './pages/Contact/ContactPage';
import AboutPage from './pages/About/AboutPage';

function AppContent() {
  const { pathname } = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const returnUrl = '/';
  const page = pathname === '/drone' ? <ServicePage menuOpen={menuOpen} service="drone" /> : pathname === '/fpv' ? <ServicePage menuOpen={menuOpen} service="fpv" /> : pathname === '/weddings' ? <ServicePage menuOpen={menuOpen} service="weddings" /> : pathname === '/videography' ? <ServicePage menuOpen={menuOpen} service="videography" /> : pathname === '/contact' ? <ContactPage menuOpen={menuOpen} /> : pathname === '/about' ? <AboutPage menuOpen={menuOpen} /> : <HomePage menuOpen={menuOpen} />;
  return <div className={`App ${pathname !== '/' ? 'App--inner' : ''}`}><Header menuOpen={menuOpen} setMenuOpen={setMenuOpen} />{pathname !== '/' && <Link to={returnUrl} className="page-close" aria-label="Close page"><span>×</span></Link>}<main className="main-content"><AnimatePresence mode="wait" key={pathname}><PageTransition>{page}</PageTransition></AnimatePresence></main>{pathname !== '/' && <Footer />}</div>;
}
function App() { return <AppContent />; }
export default App;
